import ContentLayout from "../components/ContentLayout";
import Calendar from "../components/Calendar/Calendar";
import { useEffect, useRef, useState } from "react";
import { useWindowSize } from "../hooks/useWindowSize";
import "./page.css";
import { useI18n } from "../i18n";

const Title = () => {
  const { t } = useI18n();
  const title = t("nav.home") + " - " + t("meta.appName");
  return (
    <>
      <title>{title}</title>
    </>
  );
};

const Content = ({
  container_offsetLeft,
}: {
  container_offsetLeft: number;
}) => {
  return <Calendar container_offsetLeft={container_offsetLeft}></Calendar>;
};

export default function Home() {
  const containerRef = useRef<HTMLDivElement>(null);
  const { width } = useWindowSize();
  const [container_offsetLeft, setContainer_offsetLeft] = useState(0);

  useEffect(() => {
    if (!window || !containerRef?.current) {
      return;
    }
    const style = window.getComputedStyle(
      containerRef?.current as HTMLDivElement,
    );
    if (!style) {
      return;
    }
    setContainer_offsetLeft(containerRef?.current?.offsetLeft ?? 0);
  }, [containerRef?.current?.offsetLeft, width]);

  return (
    <ContentLayout
      header={<Title />}
      content={<Content container_offsetLeft={container_offsetLeft} />}
      ref={containerRef}
    />
  );
}
